import * as React from "react";

/**
 * Haul Monitor — Perspective Block logomark (JS / no TS types).
 * See HaulMonitorLogo.tsx for the typed version.
 */

const PATHS = (
  <>
    <path d="M 30 18 L 38 18 L 44 86 L 22 86 Z" />
    <path d="M 62 18 L 70 18 L 78 86 L 56 86 Z" />
    <path d="M 35 48 L 65 48 L 66 56 L 34 56 Z" />
  </>
);

export function HaulMonitorLogo({
  size = 32,
  color = "currentColor",
  variant = "mark",
  title = "Haul Monitor",
  className,
  style,
}) {
  const a11y = title
    ? { role: "img", "aria-label": title }
    : { role: "img", "aria-hidden": true };

  if (variant === "mark") {
    return (
      <svg width={size} height={size} viewBox="0 0 100 100" fill={color} className={className} style={style} {...a11y}>
        {title ? <title>{title}</title> : null}
        {PATHS}
      </svg>
    );
  }

  if (variant === "stacked") {
    const w = (size * 240) / 200;
    return (
      <svg width={w} height={size} viewBox="0 0 240 200" fill={color} className={className} style={style} {...a11y}>
        {title ? <title>{title}</title> : null}
        <g transform="translate(70 0)">{PATHS}</g>
        <text x="120" y="160" textAnchor="middle"
          fontFamily="'Inter Tight', 'Helvetica Neue', Helvetica, Arial, sans-serif"
          fontWeight={700} fontSize={22} letterSpacing={3} fill={color}>HAUL MONITOR</text>
      </svg>
    );
  }

  const w = (size * 420) / 100;
  return (
    <svg width={w} height={size} viewBox="0 0 420 100" fill={color} className={className} style={style} {...a11y}>
      {title ? <title>{title}</title> : null}
      {PATHS}
      <text x="120" y="60"
        fontFamily="'Inter Tight', 'Helvetica Neue', Helvetica, Arial, sans-serif"
        fontWeight={700} fontSize={26} letterSpacing={3.6} fill={color}>HAUL MONITOR</text>
    </svg>
  );
}

export default HaulMonitorLogo;
